import '../css/style.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'lity/dist/lity.min.js';
import 'lity/dist/lity.min.css';

import Top from './modules/Top';
import Nav from './modules/Nav';
import NavTop from './modules/NavTop';
import ReservationBtn from './modules/ReservationBtn';
import Tab from './modules/Tab';
import FollowingTab from './modules/FollowingTab';
import LangSelect from './modules/LangSelect';

const reservationBtn = new ReservationBtn();
const langSelect = new LangSelect();

const TOP_PAGE = document.querySelector('.home');
const SERVICE_PAGE = document.querySelector('.p-service');
const DRIVERS_PAGE = document.querySelector('.p-drivers');

if (TOP_PAGE) {
  const top = new Top();
  const navTop = new NavTop();
} else {
  const nav = new Nav();
}
if (SERVICE_PAGE) {
  const tab = new Tab();
  const followingTab = new FollowingTab();
}
